
import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../../layout/header/Header";
import { Helmet } from "react-helmet";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import ThankYou from "../voucher-form/components/thank-you/ThankYou";
import PaymentStatus from "../voucher-form/components/thank-you/PaymentStatus";
import TransactionHistory from "../voucher-form/components/thank-you/TransactionHistory";
import AlertMessage from "../voucher-form/components/thank-you/AlertMessage";
import editIcon from "../../assets/icons/ic-solar_pen-bold.svg";
import RelandingPaymentStatus from "../voucher-form/components/thank-you/RelandingPaymentStatus";
import PreferentialAccordion from "../voucher-form/components/thank-you/PreferentialAccordion";
import VerifyOTPModal from "../voucher-form/components/thank-you/VerifyOTPModal";
import { COMPARE_VALUE, EOIFormStatus, FORM_PHASE } from "../../config/constant";
import {
  getVoucherById,
  sendVoucherOTP,
  VerifyOTP,
  setEditPreviewApplicant,
  reSendVoucherOTP,
  BuyNewVoucher,
  setShowThankYouMessage,
  requestCancellations,
  getEOICampaignDetails,
  getMyVoucherList,
  setActiveStep,
  setResetData as setVoucherFormResetData,
  setUnitPrefEditFromThankYou,
} from "../voucher-form/voucher-form.slice";
import { useDispatch, useSelector } from "react-redux";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./VoucherThankyou.scss";
import ConfirmDialogWithComment from "../../shared-components/confirm-dialog-with-comment/ConfirmDialogWithComment";
import ConfirmationModal from "../../shared-components/confirmation-modal/ConfirmationModal";
import { useFormik } from "formik";
import * as yup from "yup";
import { formatIndianNumber } from "../voucher-form/components/common-functions/PaymentCommonFunctions";
import MyVouchers from "../voucher-form/components/thank-you/MyVouchers";
import { getCurrentFormPhase } from "../../utilis/common-funtions";
import {
  secondsRemainingUntil,
  parsePositiveMinutes,
  getVoucherBlockedUnitWindowEndMs,
} from "../../utilis/inventory-block-timer";
import { Description } from "@mui/icons-material";
import { getOppprtunityDetails, setResetData as setNewBookingFormResetData, clearEnquiryDetails } from "../new-booking-form/new-booking-form.slice";
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  APPLICANT_UPDATE_MODE,
  canShowApplicantUpdateCTA,
} from "../../utilis/voucher-thank-you-cta";

const Thankyou = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verifiedOTP, setVerifiedOTP] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [countdownEndsAtMs, setCountdownEndsAtMs] = useState(null);
  const [paymentCountdownExpired, setPaymentCountdownExpired] =
    useState(false);
  const [extensionNoticeOpen, setExtensionNoticeOpen] = useState(false);
  /** After the main window ends, we allow one extra window only if a payment is unit-mapped. */
  const [extensionAlreadyUsed, setExtensionAlreadyUsed] = useState(false);

  const countdownEndsAtRef = useRef(null);
  const extensionAlreadyUsedRef = useRef(false);
  const lastBlockKeyRef = useRef(null);
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      selectedVoucher: "",
    },
    validationSchema: yup.object().shape({
      selectedVoucher: yup.string().notRequired(),
    }),
    onSubmit: (values) => {
    },
  });

  const {
    applicantData,
    showThankYouMessage,
    isUpgradePreferentialStep,
    myVoucherList,
  } = useSelector((state) => state.voucherForm);
  const oppId = applicantData?.opportunityId;
  const entity = getCurrentFormPhase(applicantData?.formPhase);
  const ALLOWED_STATUSES = [
    EOIFormStatus.MIS_REQUESTED_CHANGES,
    EOIFormStatus.MIS_UPDATED,
    EOIFormStatus.MIS_VERIFIED,
    EOIFormStatus.CRM_REQUESTED_CHANGES,
    EOIFormStatus.CRM_UPDATED,
    EOIFormStatus.CRM_VERIFIED,
    EOIFormStatus.UPGRADING,
    EOIFormStatus.UNVERIFIED
  ];

  const PREVIEW_ALLOWED_STATUSES = [
    EOIFormStatus.ACTIVE,
    EOIFormStatus.UPGRADED,
    EOIFormStatus.CONVERTED,
    EOIFormStatus.CANCELLED_NOT_REALISED,
    EOIFormStatus.CANCEL_REQUESTED,
    EOIFormStatus.CANCEL_ACCEPTED,
    EOIFormStatus.CANCEL_APPROVED,
    EOIFormStatus.REFUND_INITIATED,
    EOIFormStatus.CANCELLED
  ];

  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [wrongOTP, setWrongOTP] = useState(0);
  const [isBlocked, setIsBlocked] = useState(false);
  const [modalErrorMsg, setModalErrorMsg] = useState("");
  const [localThankYou, setLocalThankYou] = useState(false)
  const [cancellationReqDialog, setCancellationReqDialog] = useState({
    open: false,
    id: null,
    reason: "",
  });
  // Show View & Edit button only when ?r=... is present
  const searchParams = new URLSearchParams(location.search);
  const showViewEditButton = ALLOWED_STATUSES.includes(applicantData?.voucherFormStatus)
  const showPreviewiewButton = PREVIEW_ALLOWED_STATUSES.includes(applicantData?.voucherFormStatus)
  const showApplicantUpdateCTA = canShowApplicantUpdateCTA({
    showViewEditButton,
    showPreviewiewButton,
    oppId,
  });
  const applicantUpdateCTALabel = t(
    "voucherPreview.thankYou.updateApplicantInfo",
    "Update Applicant Info"
  );

  const referralCode = searchParams.get("r");
  const showButtonCustOnly = !referralCode;

  const blockedUnit = applicantData?.blockedUnit;

  const blockStatus = (bu) =>
    bu
      ? String(bu.status || "").trim().toLowerCase().replaceAll(/\s+/g, " ")
      : "";

  const isBlockingApproved = (bu) => bu && blockStatus(bu) === "approved";

  const hasUnitMappedPayment = useMemo(
    () =>
      Array.isArray(applicantData?.payments) &&
      applicantData.payments.some((p) => p?.isUnitMapped === true),
    [applicantData?.payments]
  );

  const showUnitBlockHeader = verifiedOTP && blockedUnit != null;

  const defaultUnitBlockDurationMinutes = useMemo(
    () => parsePositiveMinutes(blockedUnit?.unitBlockDuration) ?? 10,
    [blockedUnit?.unitBlockDuration]
  );

  const activeTimerExtensionMinutes = useMemo(
    () => parsePositiveMinutes(blockedUnit?.timerExtension) ?? 0,
    [blockedUnit?.timerExtension]
  );

  // Refs mirror state so the 1s timer always reads the latest end time, and server sync can skip while a client extension is still running.
  useEffect(() => {
    countdownEndsAtRef.current = countdownEndsAtMs;
  }, [countdownEndsAtMs]);

  useEffect(() => {
    extensionAlreadyUsedRef.current = extensionAlreadyUsed;
  }, [extensionAlreadyUsed]);

  useEffect(() => {
    const stopCountdown = () => {
      lastBlockKeyRef.current = null;
      setCountdownEndsAtMs(null);
      setTimerActive(false);
      setTimeLeft(0);
      setPaymentCountdownExpired(false);
      setExtensionAlreadyUsed(false);
      setExtensionNoticeOpen(false);
    };

    if (!verifiedOTP || !blockedUnit) {
      stopCountdown();
      return;
    }

    if (isBlockingApproved(blockedUnit)) {
      stopCountdown();
      return;
    }

    const blockKey = `${blockedUnit.id ?? ""}|${blockedUnit.unitBlockExpiry ?? ""}`;
    if (blockKey !== lastBlockKeyRef.current) {
      lastBlockKeyRef.current = blockKey;
      setExtensionAlreadyUsed(false);
    }

    const currentEndMs = countdownEndsAtRef.current;
    if (
      extensionAlreadyUsedRef.current &&
      currentEndMs != null &&
      currentEndMs > Date.now()
    ) {
      return;
    }

    const serverEndMs = getVoucherBlockedUnitWindowEndMs(blockedUnit);
    if (serverEndMs == null || serverEndMs <= Date.now()) {
      setCountdownEndsAtMs(null);
      setTimerActive(false);
      setTimeLeft(0);
      setPaymentCountdownExpired(true);
      return;
    }

    setCountdownEndsAtMs(serverEndMs);
    setTimeLeft(secondsRemainingUntil(serverEndMs));
    setTimerActive(true);
    setPaymentCountdownExpired(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    verifiedOTP,
    blockedUnit?.id,
    blockedUnit?.unitBlockExpiry,
    blockedUnit?.createdAt,
    blockedUnit?.unitBlockDuration,
    blockedUnit?.status,
  ]);

  useEffect(() => {
    if (voucherId) {
      dispatch(setVoucherFormResetData());
      dispatch(setNewBookingFormResetData());
      (async () => {
        try {
          let url = `/${voucherId}`;
          if (referralCode) {
            url += `?r=${encodeURIComponent(referralCode)}`;
          }
          const res = await dispatch(getVoucherById(url)).unwrap();

          dispatch(getEOICampaignDetails({ campaignId: res?.campaignId || "" }));
          if (res?.toBeVerified) {
            setIsModalOpen(true);
            dispatch(setShowThankYouMessage(false));

            await dispatch(
              sendVoucherOTP({ voucherId })
            ).unwrap();

            // ✅ after this log you can add your condition check
          } else {
            setVerifiedOTP(true);
          }
        } catch (error) {
          console.error("Error fetching voucher or sending OTP:", error);
          setSnackbarConfig({
            open: true,
            message: error?.errors?.message || "Failed to send otp",
            severity: "error",
          });
          if (
            error?.errors?.message ===
            "Too many failed OTP attempts. Please try again later."
          ) {
            setIsBlocked(true);
            setModalErrorMsg(
              "Too many failed attempts. Please wait a while before trying again."
            );
          }

          setWrongOTP((prev) => prev + 1);
        }
      })();
    }
    if (voucherId) {
      dispatch(getMyVoucherList({ voucherId }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voucherId]);

  useEffect(() => {
    if (formik?.values?.selectedVoucher) {
      history.push(`/voucher-form/${formik?.values?.selectedVoucher}`)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.selectedVoucher])



  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleVerifyOTP = async (otp) => {
    if (isBlocked) {
      setSnackbarConfig({
        open: true,
        message:
          "Too many failed attempts. Please try again later or resend OTP.",
        severity: "error",
      });
      return;
    }

    if (otp?.length !== 6) {
      setSnackbarConfig({
        open: true,
        message: "Invalid OTP format!",
        severity: "error",
      });
      return;
    }

    try {
      const payload = { voucherId, otp };
      const res = await dispatch(VerifyOTP(payload)).unwrap();

      if (res?.verified) {
        setVerifiedOTP(true);
        setIsModalOpen(false);
        setWrongOTP(0); // reset counter
        setSnackbarConfig({
          open: true,
          message: res?.message || "OTP verified successfully!",
          severity: "success",
        });
      } else {
        // API responded but OTP is wrong
        const newCount = wrongOTP + 1;
        setWrongOTP(newCount);
        if (newCount === 5) {
          setModalErrorMsg(
            "You have entered an invalid OTP 5 times. Please try again later."
          );
        }
        if (newCount >= 5) {
          setIsBlocked(true);
          setSnackbarConfig({
            open: true,
            message:
              "You have exceeded maximum OTP attempts. Please resend OTP.",
            severity: "error",
          });
        } else {
          setSnackbarConfig({
            open: true,
            message: "Incorrect OTP. Attempts left: " + (5 - newCount),
            severity: "error",
          });
        }
      }
    } catch (error) {
      // API error handling
      setSnackbarConfig({
        open: true,
        message: error?.errors?.message || "OTP Verification Error!",
        severity: "error",
      });
      console.error("OTP Verification Error:", error);

      // also count as a failed attempt
      const newCount = wrongOTP + 1;
      setWrongOTP(newCount);
      if (newCount >= 5) {
        setIsBlocked(true);
        setSnackbarConfig({
          open: true,
          message: "You have exceeded maximum OTP attempts. Please resend OTP.",
          severity: "error",
        });
      }
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleResendOTP = async () => {
    try {
      const otpRes = await dispatch(reSendVoucherOTP({ voucherId })).unwrap();
      if (otpRes?.success || otpRes?.data?.success) {
        setSnackbarConfig({
          open: true,
          message: otpRes?.response?.message || "OTP resent successfully!",
          severity: "success",
        });
      } else {
        setSnackbarConfig({
          open: true,
          message: otpRes?.response?.message || otpRes?.data?.message || "Failed to resend OTP",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const HandleBuyNewVoucher = async () => {
    try {
      const payload = { voucherId: applicantData?.id };
      const res = await dispatch(BuyNewVoucher(payload)).unwrap();
      setSnackbarConfig({
        open: true,
        message: "Voucher purchased successfully!",
        severity: "success",
      });
      if (res?.voucherFormUrl) {
        window.open(res.voucherFormUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Buy New Voucher Error:", error);
      setSnackbarConfig({
        open: true,
        message:
          error?.errors?.message ||
          "Something went wrong while buying voucher!",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (showThankYouMessage) {
      setLocalThankYou(true)
      dispatch(setShowThankYouMessage(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      applicantData?.voucherFormStatus === EOIFormStatus?.CREATED ||
      applicantData?.voucherFormStatus === EOIFormStatus?.IN_PROGRESS
    ) {
      history.push(`/voucher-form/${voucherId}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData]);

  useEffect(() => {
    const applicantMatchesCurrentVoucher = applicantData?.voucherId === voucherId;
    if (applicantMatchesCurrentVoucher) {
      if (oppId) {
        dispatch(getOppprtunityDetails(`/${oppId}`));
      } else {
        dispatch(clearEnquiryDetails());
      }
    }
  }, [oppId, dispatch, applicantData?.voucherId, voucherId]);

  const handleCancelRequest = () => {
    dispatch(
      requestCancellations({
        voucherId: applicantData?.voucherId,
        cancelReason: cancellationReqDialog?.reason,
      })
    )
      .unwrap() // gives direct access to fulfilled/rejected values
      .then((res) => {
        if (res.success) {
          setCancellationReqDialog({ open: false, id: null, reason: "" });
          setSnackbarConfig({
            open: true,
            message: 'Cancellation requested successfully',
            severity: "success",
          });
          dispatch(getVoucherById(`/${voucherId}`))
        }
      })
      .catch((err) => {
        console.error("Cancel failed:", err);
        setSnackbarConfig({
          open: true,
          message: err?.errors?.message || "Failed to send otp",
          severity: "error",
        });
      });

  };

  useEffect(() => {
    if (!timerActive || countdownEndsAtMs == null) {
      return undefined;
    }

    const tick = () => {
      const deadlineMs = countdownEndsAtRef.current;
      if (deadlineMs == null) {
        return;
      }

      const secondsLeft = secondsRemainingUntil(deadlineMs);
      setTimeLeft(secondsLeft);
      if (secondsLeft > 0) {
        return;
      }

      setTimerActive(false);

      const extraMinutes = activeTimerExtensionMinutes;
      const canExtendOnce =
        hasUnitMappedPayment && extraMinutes > 0 && !extensionAlreadyUsed;

      if (!canExtendOnce) {
        toast.error("Time expired. Please block the unit again.");
        setTimeLeft(0);
        setPaymentCountdownExpired(true);
        setCountdownEndsAtMs(null);
        return;
      }

      setExtensionAlreadyUsed(true);
      setExtensionNoticeOpen(true);
      const newEndMs = Date.now() + extraMinutes * 60 * 1000;
      setCountdownEndsAtMs(newEndMs);
      setTimeLeft(secondsRemainingUntil(newEndMs));
      setPaymentCountdownExpired(false);
      setTimerActive(true);
    };

    const intervalId = setInterval(tick, 1000);
    tick();

    return () => clearInterval(intervalId);
  }, [
    timerActive,
    countdownEndsAtMs,
    hasUnitMappedPayment,
    activeTimerExtensionMinutes,
    extensionAlreadyUsed,
  ]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const MY_VOUCHERS_OPTIONS = useMemo(() => {
    return myVoucherList?.map(item => ({
      value: item.voucherId,
      name: item.uniqueReferenceId,
    })) || [];
  }, [myVoucherList]);

  let headingText = "Voucher Form";

  if (localThankYou) {
    headingText = "Thank You";
  } else if (
    applicantData?.isUpgradableToEOI &&
    !localThankYou &&
    verifiedOTP
  ) {
    headingText = "Voucher Form - Upgrade to Preferential EOI";
  } else if (
    !localThankYou &&
    verifiedOTP &&
    !applicantData.isUpgradableToEOI
  ) {
    headingText = "My Voucher/EOI";
  }

  return (
    <div className="thankyou-page">
      <Helmet>
        <title>Thank You - {applicantData?.formPhase === FORM_PHASE.VOUCHER && !isUpgradePreferentialStep ? "Voucher Form" : "Expression of Interest Form"}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header logo={COMPARE_VALUE?.Puravankara} isMenuOpen={false} />
      {verifiedOTP && (
        <Grid
          container
          spacing={0}
          sx={{
            p: 0,
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              pt: {
                xs: "16px",
                sm: "30px",
                md: "36px",
              },
              pb: {
                xs: "16px",
                sm: "18px",
                md: "20px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                alignItems: "center",
                justifyContent: showUnitBlockHeader
                  ? "space-between"
                  : "center",
                gap: 1.5,
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  color: "#1A407D",
                  fontSize: {
                    xs: "20px",
                    sm: "20px",
                    md: "24px",
                  },
                  fontWeight: "700",
                  lineHeight: {
                    xs: "28px",
                    sm: "32px",
                    md: "36px",
                  },
                  textAlign: showUnitBlockHeader ? "left" : "center",
                  flex: showUnitBlockHeader ? "1 1 auto" : "none",
                  minWidth: 0,
                }}
              >
                {headingText}
              </Typography>
              {showUnitBlockHeader &&
                (isBlockingApproved(blockedUnit) ? (
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#118D57",
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Unit mapped
                  </Typography>
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    sx={{
                      flexShrink: 0,
                      minWidth: "4.75rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <AccessTimeFilledIcon
                      sx={{
                        fontSize: 23,
                        color:
                          paymentCountdownExpired || timeLeft <= 300
                            ? "red"
                            : "green",
                      }}
                    />
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "23px",
                        fontWeight: 600,
                        fontVariantNumeric: "tabular-nums",
                        color:
                          paymentCountdownExpired || timeLeft <= 300
                            ? "red"
                            : "green",
                      }}
                    >
                      {formatTime(paymentCountdownExpired ? 0 : timeLeft)}
                    </Typography>
                  </Box>
                ))}
            </Box>
          </Grid>
        </Grid>
      )}

      {verifiedOTP && (
        <Box
          sx={{
            borderRadius: "8px",
            border: "1px solid rgba(26, 64, 125, 0.30)",
            padding: {
              xs: "24px",
              sm: "24px",
              lg: "24px 24px 24px 24px",
            },
            marginLeft: {
              xs: "16px",
              sm: "16px",
              lg: "70px",
            },
            marginRight: {
              xs: "16px",
              sm: "16px",
              lg: "70px",
            },
            marginBottom: {
              xs: "50px",
              sm: "70px",
              lg: "70px",
            },
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="stretch"
            direction="row"
            wrap={{ xs: "wrap", sm: "nowrap" }}
            sx={{
              flexDirection: {
                xs: "column", // below 1000px → column
              },
              "@media (min-width:1001px)": {
                flexDirection: "row", // above 1000px → row
                flexWrap: "nowrap",
              },
            }} // prevent wrapping until 1000px
          >
            {/* Left Card */}
            <Grid
              item
              xs={12}
              sm
              md
              lg
              xl
              sx={{ flex: { xs: "1 1 100%", sm: "1 1 70%" } }} // 70% until 1000px
            >
              {verifiedOTP && !localThankYou ? (
                <RelandingPaymentStatus />
              ) : null}

              {localThankYou && <ThankYou />}
              {localThankYou && (!applicantData?.paidVoucherId || !applicantData?.stdEoiId || !applicantData?.preEoiId) && (
                <AlertMessage
                  type="warning"
                  title={`${entity} ID Assignment Pending`}
                  message={`${entity} ID will be assigned once the complete amount of ₹${formatIndianNumber(applicantData?.paymentDetails?.amountPayable)} is received.`}
                  highlight={`₹${formatIndianNumber(applicantData?.paymentDetails?.amountPayable)} is received`}
                />
              )}
            </Grid>

            {/* Divider for desktop (vertical) */}
            <Grid
              item
              md="auto"
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                alignItems: "stretch",
              }}
            >
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </Grid>

            {/* Right Card */}
            <Grid
              item
              xs={12}
              sm
              md
              lg
              xl
              sx={{ flex: { xs: "1 1 100%", sm: "1 1 30%" } }} // 30% until 1000px
            >
              {MY_VOUCHERS_OPTIONS?.length > 0 && (
                <MyVouchers options={MY_VOUCHERS_OPTIONS} formik={formik} />
              )}

              {applicantData?.isUpgradableToEOI && <PreferentialAccordion />}
              {/* Need to uncomment when needed */}

              {oppId ? (
                <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                  <Button
                    variant="outlined"
                    startIcon={<Description />}
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#1A407D",
                      borderColor: "#1A407D",
                      borderRadius: "8px",
                      "&:hover": {
                        borderColor: "#1A407D",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      window.open(
                        `/booking-form/${oppId}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  >
                    {applicantUpdateCTALabel}
                  </Button>
                </Box>
              ) : (
                showApplicantUpdateCTA && (
                  <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                    <Button
                      variant="outlined"
                      startIcon={<Description />}
                      aria-label={applicantUpdateCTALabel}
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#1A407D",
                        borderColor: "#1A407D",
                        borderRadius: "8px",
                        "&:hover": {
                          borderColor: "#1A407D",
                          backgroundColor: "transparent",
                        },
                      }}
                      onClick={() => {
                        history.push(
                          `/voucher-form/${voucherId}?mode=${APPLICANT_UPDATE_MODE}`
                        );
                      }}
                    >
                      {applicantUpdateCTALabel}
                    </Button>
                  </Box>
                )
              )}

              {localThankYou && <PaymentStatus />}
              <TransactionHistory />
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between", // Keep balanced layout
              alignItems: "center",
              mt: "30px",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap", }}>
              {showViewEditButton && (
                <Button
                  variant="outlined"
                  startIcon={<img src={editIcon} alt="edit-icon" />}
                  sx={{
                    border: "1px solid #D0D5DD",
                    color: "#1A407D",
                    textTransform: "none",
                    fontSize: "16px",
                    px: 2,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    dispatch(setUnitPrefEditFromThankYou(true));
                    dispatch(setActiveStep(0));
                    dispatch(setEditPreviewApplicant(true));
                    history.push(`/voucher-form/${voucherId}`);
                  }}
                >
                  View & Edit Form
                </Button>
              )}
              {showPreviewiewButton && <Button
                variant="outlined"
                sx={{
                  border: "1px solid #D0D5DD",
                  color: "#1A407D",
                  textTransform: "none",
                  fontSize: "16px",
                  px: 2,
                  py: 1,
                  borderRadius: "8px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  window.open(`/voucher-preview/${voucherId}`, "_blank", "noopener,noreferrer");
                }}
              >
                Preview Form
              </Button>}

            </Box>
            {showButtonCustOnly && (<Button
              variant="contained"
              onClick={HandleBuyNewVoucher}
              sx={{
                backgroundColor: "#1A407D",
                textTransform: "none",
                fontSize: "16px",
                px: 3,
                py: 1,
                borderRadius: "8px",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#1A407D",
                },
              }}
            >
              Buy New {entity}
            </Button>)}

          </Box>
        </Box>
      )}

      <ConfirmDialogWithComment
        open={cancellationReqDialog.open}
        onClose={() => setCancellationReqDialog({ open: false, id: null, reason: '' })}
        title="Request Cancellation"
        confirmText="Are you sure you want to cancel Voucher/EOI?"
        textValue={cancellationReqDialog.reason}
        onTextChange={(e) =>
          setCancellationReqDialog((prev) => ({ ...prev, reason: e.target.value }))
        }
        placeholder="Enter reason for cancellation request"
        confirmBtnDisabled={cancellationReqDialog?.reason?.trim()?.length === 0}
        confirmBtnLabel="Yes, Cancel"
        onSubmit={() => { handleCancelRequest() }}
      />
      {isModalOpen && <VerifyOTPModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onVerify={(otp) => handleVerifyOTP(otp)}
        isBlocked={wrongOTP >= 5 || isBlocked}
        handleResend={handleResendOTP}
        errorMessage={modalErrorMsg}
      />}
      <ConfirmationModal
        open={extensionNoticeOpen}
        onClose={() => setExtensionNoticeOpen(false)}
        title="Time extension"
        confirmText="OK"
        onConfirm={() => setExtensionNoticeOpen(false)}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
          This unit was blocked for {defaultUnitBlockDurationMinutes} minutes
          and is about to expire.
        </Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
          We&apos;ve extended your time by {activeTimerExtensionMinutes} more
          minutes.
        </Typography>
      </ConfirmationModal>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default Thankyou;
